export enum TimeUnit{
  DAYS
}

export module TimeUnit{
  export function toMilliseconds(value: number, unit : TimeUnit) : number {
    switch (unit){
      case TimeUnit.DAYS:
        return value * 1000 * 60 * 60 * 24;
    }
  }
}
